// import polyline from '@mapbox/polyline';
// import axios from 'axios'
// import { MAPBOX_ACCESS_TOKEN } from 'src/constants/Defaultvalues';

// const MAPBOX_TOKEN = MAPBOX_ACCESS_TOKEN 
// /**
//  * @param {string} encoded Google overview_polyline.points
//  * @returns {number[][]} [[lng, lat], …]
//  */
// export const decodeGooglePolyline = (encoded) =>
//   polyline.decode(encoded).map(([lat, lng]) => [lng, lat]);

// const joinCoords = (pts) => pts.map(p => `${p.lng},${p.lat}`).join(';')

// /** Plain Directions request (≤ 25 coordinates) */
// // const mapboxDirections = async (coords) => {
// //   const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${joinCoords(
// //     coords
// //   )}?geometries=geojson&overview=full&steps=true&access_token=${MAPBOX_TOKEN}`

// //   const { data } = await axios.get(url)
// //   if (!data.routes || !data.routes.length) throw new Error('No route found')
// //   return data.routes[0]
// // }

// const mapboxDirections = async (coords) => {
//   const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${joinCoords(
//     coords
//   )}?geometries=geojson&overview=full&steps=true&access_token=${MAPBOX_TOKEN}`

//   const { data } = await axios.get(url)
//   if (!data.routes?.length) throw new Error('No route found')
//   return data.routes[0]
// }

// /** TSP optimisation with the Optimisation API */
// // const mapboxOptimisedTrip = async (coords) => {
// //   const url = `https://api.mapbox.com/optimized-trips/v1/mapbox/driving/${joinCoords(
// //     coords
// //   )}?geometries=geojson&overview=full&source=first&destination=last&roundtrip=false&access_token=${MAPBOX_TOKEN}`

// //   const { data } = await axios.get(url)
// //   if (!data.trips || !data.trips.length) throw new Error('No trip found')
// //   return { trip: data.trips[0], waypoints: data.waypoints }
// // }

//  const mapboxOptimisedTrip = async (coords) => {
//   if (coords.length > 12) {                                  // 🔄 NEW guard
//     throw new Error('Optimised Trip API supports max 12 coordinates')
//   }

//   const url = `https://api.mapbox.com/optimized-trips/v1/mapbox/driving/${joinCoords(
//     coords
//   )}?geometries=geojson&overview=full&source=first&destination=last&roundtrip=false&access_token=${MAPBOX_TOKEN}`

//   const { data } = await axios.get(url)
//   if (!data.trips?.length) throw new Error('No trip found')
//   return { trip: data.trips[0], waypoints: data.waypoints }
// }

// export { mapboxDirections, mapboxOptimisedTrip }



import polyline from '@mapbox/polyline'
import axios from 'axios'
import { MAPBOX_ACCESS_TOKEN } from 'src/constants/Defaultvalues'

const MAPBOX_TOKEN = MAPBOX_ACCESS_TOKEN

const fmt = n => Number(n).toFixed(6)
const joinCoords = pts => pts.map(p => `${fmt(p.lng)},${fmt(p.lat)}`).join(';')

export const decodeGooglePolyline = encoded =>
  polyline.decode(encoded).map(([lat, lng]) => [lng, lat])

export const mapboxDirections = async (coords) => {
  if (coords.length < 2) throw new Error('Minimum 2 coordinates required')

  const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${joinCoords(
    coords
  )}?geometries=geojson&overview=full&steps=false&access_token=${MAPBOX_TOKEN}`

  try {
    const { data } = await axios.get(url)
    if (!data.routes?.length) throw new Error('No route found')
    return data.routes[0]
  } catch (err) {
    const msg = err?.response?.data?.message || err.message
    throw new Error(`Mapbox ${err.response?.status || ''}: ${msg}`)
  }
}

export const mapboxOptimisedTrip = async (coords) => {
  if (coords.length > 12)
    throw new Error('Optimised Trip API supports max 12 coordinates')

  const url = `https://api.mapbox.com/optimized-trips/v1/mapbox/driving/${joinCoords(
    coords
  )}?geometries=geojson&overview=full&source=first&destination=last&roundtrip=false&access_token=${MAPBOX_TOKEN}`

  const { data } = await axios.get(url)
  if (!data.trips?.length) throw new Error('No trip found')
  return { trip: data.trips[0], waypoints: data.waypoints }
}


const MAX_WPS = 23;                 // 23 + origin + destination = 25

export function chunkWaypoints(allWps, size = MAX_WPS) {
  const chunks = [];
  for (let i = 0; i < allWps.length; i += size) {
    chunks.push(allWps.slice(i, i + size));
  }
  return chunks;
}

export function buildRoute(origin, destination, rawWaypoints) {
  const directionsService = new window.google.maps.DirectionsService();
  const waypointChunks = chunkWaypoints(rawWaypoints);   // already ≤ 23

  const dirPromises = waypointChunks.map(
    (wps) =>
      new Promise((resolve, reject) =>
        directionsService.route(
          {
            origin,
            destination,
            waypoints: wps,
            optimizeWaypoints: true,
            travelMode: 'DRIVING'
          },
          (res, status) => (status === 'OK' ? resolve(res) : reject(status))
        )
      )
  );

  return Promise.all(dirPromises);  // → [DirectionsResult, …]
}

